import script from "./CreateAssignmentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateAssignmentModal.vue?vue&type=script&setup=true&lang=js"

import "./CreateAssignmentModal.vue?vue&type=style&index=0&id=6c1eb204&scoped=true&lang=css"
script.__scopeId = "data-v-6c1eb204"

export default script